import React from "react";
import Label from "react-bootstrap/Badge";

import { faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/* eslint-disable jsx-a11y/anchor-is-valid */
function AdditionalToggleColumn({
  toggleTitle,
  toggleEnabled = true,
  setToggleEnabled,
  toggleEnabledTooltip = "",
  toggleDisabledTooltip = "",
  toggleEnabledText = "An",
  toggleDisabledText = "Aus",
  debugLayout = false,
  toggleClickable,
}) {
  return (
    <table style={debugLayout ? { border: "1px solid #ddd" } : {}} border={debugLayout ? 1 : 0}>
      <tbody>
        <tr style={{ height: "2px" }}>
          <td
            style={{
              textAlign: "center",
              paddingLeft: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            <h5
              style={{
                textAlign: "center",
                margin: "4px",
              }}
            >
              <b>{toggleTitle}</b>
            </h5>
          </td>
        </tr>
        <tr style={{ height: "100%" }}>
          <td
            style={{
              textAlign: "center",
              verticalAlign: "center",
              paddingLeft: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            <table
              border={0}
              style={{
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      verticalAlign: "center",
                    }}
                  >
                    <a
                      style={{
                        textDecoration: "none",
                        cursor: toggleClickable === true ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (toggleClickable === true) {
                          setToggleEnabled(!(toggleEnabled === true));
                        }
                      }}
                      title={toggleEnabled === true ? toggleEnabledTooltip : toggleDisabledTooltip}
                    >
                      <Label
                        style={{ padding: 4, width: 39 }}
                        variant={
                          toggleEnabled === true && toggleClickable === true
                            ? "primary"
                            : "secondary"
                        }
                      >
                        <FontAwesomeIcon
                          className="fa-1x"
                          icon={toggleEnabled === true ? faToggleOn : faToggleOff}
                        />
                        {toggleEnabled === true
                          ? " " + toggleEnabledText
                          : " " + toggleDisabledText}{" "}
                      </Label>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default AdditionalToggleColumn;
